// @ts-ignore
import VCalendar from "v-calendar";
import Vue from "vue";

Vue.use(VCalendar);
